function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 64"
}, props), React.createElement("path", {
  d: "M52.532 44.525c-14.056 7.893-28.803 13.783-38.634 17.32-5.516 1.985-11.612-1.467-11.695-6.633l-.615-36.744C1.414 8.269 11.845.364 23.527 1.842c20.137 2.553 47.152 5.546 65.879 4.66 6.835-.327 11.206 6.25 7.436 11.187-7.388 9.68-20.954 21.876-44.31 26.836z",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M52.531 44.524s7.772-7.893 2.305-27.674M65.813 6.098l5.62 4.803-4.573 4.592 6.319 5.402-4.818 4.399 5.593 5.02M78.031 6.615l4.497 3.935-4.12 4.067 4.33 3.59",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M41.704 9.124c-11.772 4.577-19.57 10.016-24.942 15.268-4.415 4.318-7.17 8.488-9.132 11.878l-.3-17.88s0 0 0 0c-.051-3.043 1.277-5.938 3.8-8.151 2.542-2.232 5.941-3.475 9.576-3.475.666 0 1.343.04 2.003.124h.001c5.613.711 12.117 1.501 18.994 2.236z",
  fill: "#fff",
  stroke: "#5FB9D7",
  strokeWidth: "2"
})));